import { render } from "./NotFoundPage.vue?vue&type=template&id=3d98dacc"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/42/uchowanca/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__